/* src/app/modules/accounting/movements/accounting-movements-list.component.css */
.ac-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.ac-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.ac-page-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ac-page-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, .12);
  flex-shrink: 0;
}
.ac-page-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.ac-page-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a1d23;
}
.ac-page-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.ac-page-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ac-desc-link {
  cursor: pointer;
  color: var(--cf-brand-dark,#d48f00);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.ac-desc-link:hover {
  color: #b8790a;
}
.ac-toolbar {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .07);
  border: 1px solid #e5e7eb;
  padding: 20px 20px 12px;
}
.ac-toolbar__fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}
.ac-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}
.ac-btn-primary {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.ac-btn-export {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.ac-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.ac-loading__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, .12);
}
.ac-loading__icon mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #e3fd64;
}
.ac-loading__dots {
  display: flex;
  gap: 8px;
}
.ac-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: .3;
  animation: ac-mv 1.2s ease-in-out infinite;
}
.ac-loading__dots span:nth-child(2) {
  animation-delay: .2s;
}
.ac-loading__dots span:nth-child(3) {
  animation-delay: .4s;
}
.ac-loading__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
@keyframes ac-mv {
  0%, 80%, 100% {
    opacity: .3;
    transform: scale(.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.ac-inline-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
}
.ac-inline-dots span {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: .4;
  animation: ac-mv 1.1s ease-in-out infinite;
}
.ac-inline-dots span:nth-child(2) {
  animation-delay: .18s;
}
.ac-inline-dots span:nth-child(3) {
  animation-delay: .36s;
}
.ac-table-wrap {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .07);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}
table td,
table th {
  padding: 6px 10px !important;
}
.mat-mdc-header-cell {
  background: #1e2235 !important;
  color: rgba(255, 255, 255, .87) !important;
  font-weight: 600 !important;
}
td,
th {
  border: 1px solid #e5e7eb !important;
}
.table thead th {
  border-bottom: 2px solid #e3fd64 !important;
}
td.accountNumber {
  cursor: pointer;
}
td.is-odd {
  background-color: #f9fafb;
}
td.regularizado {
  background-color: #fef9c3;
}
td.cierre {
  background-color: #d1fae5;
}
td.apertura {
  background-color: #fff7ed;
}
.hover-ledger:hover {
  background-color: rgba(227, 253, 100, .15);
  cursor: pointer;
}
.ac-desc-nodoc {
  color: #6b7280;
}
.ac-nodoc-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  vertical-align: middle;
  color: var(--cf-warning, #d97706);
}
/*# sourceMappingURL=accounting-movements-list.component.css.map */
